/**
 * Class represents a Name Value Pair
 */
export class NVP {

    /**
     * The key
     */
    key: string | number = '';

    /**
     * The value
     */
    value: string | number = '';
}